import React from 'react';
import {
  Box,
} from 'grommet';
import { Search as SearchIcon } from 'grommet-icons';
import SearchBar from '../SearchBar/SearchBar';


function SearchBox(props) {
  const {
    data, size, target, setTarget,
  } = props;
  const [isSearchBoxFocused, setSearchBoxFocused] = React.useState(false);


  function boxWidth(screenSize) {
    if (screenSize === 'small') {
      return ('90vw');
    }
    return ('50vw');
  }

  return (
    <Box
      direction="row"
      align="center"
      background="white"
      border={{ side: 'all', color: isSearchBoxFocused ? 'green' : 'red' }}
      elevation="small"
      fill="horizontal"
      gap="small"
      pad={{
        horizontal: 'small',
      }}
      margin="medium"
      round="medium"
      style={{ width: boxWidth(size) }}
    >
      <SearchIcon />
      <SearchBar data={data} focus={setSearchBoxFocused} target={target} setTarget={setTarget} />
    </Box>
  );
}

export default SearchBox;
